import React from 'react';

function Slider() {
  return (
    <section className="banner-sec">
      <div className="slider stick-dots">
        <div
          className="slide"
          style={{ backgroundImage: 'url(/project/images/header-img.jpg)' }}
        >
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-5">
                <div className="slide__content">
                  <div className="slide__content--headings">
                    <h6 className="wow fadeInDown" data-wow-delay="0.4s">
                      Welcome to EV Parts nz
                    </h6>
                    <h1 className="wow fadeInUp" data-wow-delay="0.6s">
                      Car Wreckers & Auto Parts Experts
                    </h1>
                    <p className="wow fadeInUp" data-wow-delay="0.8s">
                      Lorem ipsum dolor sit amet consectetur adipisicing elit. Id
                      adipisci molestias labore odit error dolor quaerat nulla aut,
                      accusantium repellendus.
                    </p>
                    <div className="btn-red wow fadeInUp" data-wow-delay="1s">
                      <a href="#">Read more</a>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-7 text-center">
                <div
                  className="header-text-img wow fadeInRight"
                  data-wow-delay="0.5s"
                >
                  <div className="header-img-box">
                    <div
                      className="img-header-car wow fadeInUp"
                      data-wow-delay="1.6s"
                    >
                      <img src="/project/images/car-img.png" alt="Car Image" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Slider;
